export default "__VITE_ASSET__CUPU3nRa__"